<template>
  <main class="home-page">
    <!-- Hero Banner Section -->
    <div class="hero bg-gray-50 relative">
      <!-- Warning Banner -->
      <div v-if="showWarningBanner" class="warning-banner absolute top-4 left-1/2 transform -translate-x-1/2 z-10 bg-white bg-opacity-90 py-2 px-3 rounded-lg shadow-md">
        <div class="flex items-center gap-3">
          <!-- Left Icon -->
          <div class="w-8 h-8 bg-white rounded-full flex items-center justify-center flex-shrink-0">
            <span class="text-gray-800 text-lg font-bold">！</span>
          </div>

          <!-- Center Text -->
          <p class="text-gray-800 text-sm leading-relaxed">
            {{ $t('home.fraudWarning') }}
          </p>

          <!-- Right Close Button -->
          <button @click="closeWarningBanner" class="text-gray-500 hover:text-gray-700 text-xl font-bold flex-shrink-0">
            ×
          </button>
        </div>
      </div>

      <div class="mx-auto">
        <img :src="getImageUrl('image_hero_banner', '../assets/组224.png')" :alt="getContent('home_hero_banner_alt', '顶部图片')" class="w-full h-auto object-cover" />
      </div>
    </div>

    <!-- 合作伙伴 -->
    <section class="partner-section bg-white py-12 lg:py-16">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <h2 class="text-2xl lg:text-2xl font-bold text-gray-900 mb-8 text-left">
          {{ getContent('home_partner_title', '合作伙伴') }}
        </h2>
        <!-- 合作伙伴 Logo 展示 -->
        <div class="partner-logos grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-6 lg:gap-8 items-center">
          <div class="partner-logo-item flex items-center justify-center p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors duration-300">
            <img src="../assets/hezuo/wecom-temp-2836-6edf05a9769d956854065ab4ee9b70bf.png" alt="合作伙伴" class="max-h-12 w-auto object-contain transition-all duration-300 hover:scale-105" />
          </div>
          <div class="partner-logo-item flex items-center justify-center p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors duration-300">
            <img src="../assets/hezuo/wecom-temp-3894-ace2807468a7ff305fa0a15ae83cf7fd.png" alt="合作伙伴" class="max-h-12 w-auto object-contain transition-all duration-300 hover:scale-105" />
          </div>
          <div class="partner-logo-item flex items-center justify-center p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors duration-300">
            <img src="../assets/hezuo/wecom-temp-5431-551462521f3a9aba56df97f01aa07326.png" alt="合作伙伴" class="max-h-12 w-auto object-contain transition-all duration-300 hover:scale-105" />
          </div>
          <div class="partner-logo-item flex items-center justify-center p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors duration-300">
            <img src="../assets/hezuo/wecom-temp-8197-47b1fdbda5eefae7b81ab7871804e3f0.png" alt="合作伙伴" class="max-h-12 w-auto object-contain transition-all duration-300 hover:scale-105" />
          </div>
          <div class="partner-logo-item flex items-center justify-center p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors duration-300">
            <img src="../assets/hezuo/wecom-temp-8442-b07a2e1eea071bee3d2404555a387e66.png" alt="合作伙伴" class="max-h-12 w-auto object-contain transition-all duration-300 hover:scale-105" />
          </div>
          <div class="partner-logo-item flex items-center justify-center p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors duration-300">
            <img src="../assets/hezuo/wecom-temp-10822-b4b73cc7b53c89d52cbc26ed01938306.png" alt="合作伙伴" class="max-h-12 w-auto object-contain transition-all duration-300 hover:scale-105" />
          </div>
          <div class="partner-logo-item flex items-center justify-center p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors duration-300">
            <img src="../assets/hezuo/wecom-temp-12768-540d52d727a93e7de5a60b03c312c43f.png" alt="合作伙伴" class="max-h-12 w-auto object-contain transition-all duration-300 hover:scale-105" />
          </div>
          <div class="partner-logo-item flex items-center justify-center p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors duration-300">
            <img src="../assets/hezuo/wecom-temp-12785-c1428535e1063b812178de7ab6a410a9.png" alt="合作伙伴" class="max-h-12 w-auto object-contain transition-all duration-300 hover:scale-105" />
          </div>
          <div class="partner-logo-item flex items-center justify-center p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors duration-300">
            <img src="../assets/hezuo/wecom-temp-19375-3724d39c49d953989a36b3525743a999.png" alt="合作伙伴" class="max-h-12 w-auto object-contain transition-all duration-300 hover:scale-105" />
          </div>
          <div class="partner-logo-item flex items-center justify-center p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors duration-300">
            <img src="../assets/hezuo/wecom-temp-20826-7548f7427aa66cbb171b35dd01ac8d13.png" alt="合作伙伴" class="max-h-12 w-auto object-contain transition-all duration-300 hover:scale-105" />
          </div>
          <div class="partner-logo-item flex items-center justify-center p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors duration-300">
            <img src="../assets/hezuo/wecom-temp-54127-a62725bbcf7a8b03527622be8c794a69.png" alt="合作伙伴" class="max-h-12 w-auto object-contain transition-all duration-300 hover:scale-105" />
          </div>
          <div class="partner-logo-item flex items-center justify-center p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors duration-300">
            <img src="../assets/hezuo/wecom-temp-97168-37df55e186eb48355ead1b576e3baba0.png" alt="合作伙伴" class="max-h-12 w-auto object-contain transition-all duration-300 hover:scale-105" />
          </div>
        </div>
      </div>
    </section>

    <!-- 选择理由展示区 -->
    <section class="reasons-section bg-gray-50 py-16 lg:py-20">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <!-- 大标题 -->
        <h2 class="text-3xl lg:text-4xl xl:text-5xl font-bold text-gray-900 text-center mb-12 lg:mb-16">
          {{ getContent('home_reasons_title', '为何选择红土证券？') }}
        </h2>

        <!-- 两个并排的图标及说明 -->
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          <!-- 左侧：交易支持 -->
          <div
            class="reason-card bg-white rounded-xl p-8 lg:p-10 shadow-sm hover:shadow-md transition-shadow duration-300">
            <div class="icon-container mb-6 flex justify-center">
              <img :src="getImageUrl('image_reason_1', '/assets/image1.png')" alt="">
            </div>
            <p class="text-lg lg:text-xl text-gray-700 text-center leading-relaxed">
              {{ getContent('home_reason_1_text', '在交易的每一步，助您发现机会、把握趋势，掌控全局') }}
            </p>
          </div>

          <!-- 右侧：资产管理 -->
          <div
            class="reason-card bg-white rounded-xl p-8 lg:p-10 shadow-sm hover:shadow-md transition-shadow duration-300">
            <div class="icon-container mb-6 flex justify-center">
              <img :src="getImageUrl('image_reason_2', '/assets/image2.png')" alt="">
            </div>
            <p class="text-lg lg:text-xl text-gray-700 text-center leading-relaxed">
              {{ getContent('home_reason_2_text', '专业资产管理团队，助力您财富稳健增长') }}
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- 市场深度解析：从大盘到个股 -->
    <section class="market-analysis-section bg-white py-16 lg:py-20">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <!-- 主标题 -->
        <h2 class="text-3xl lg:text-4xl xl:text-5xl font-bold text-gray-800 text-center mb-16 lg:mb-20">
          {{ getContent('home_market_title', '市场深度解析：从大盘到个股') }}
        </h2>

        <!-- 三个板块垂直排列 -->
        <div class="space-y-16 lg:space-y-20">
          <!-- 市场洞察板块 -->
          <div class="analysis-block relative flex flex-col lg:flex-row-reverse items-center gap-8 lg:gap-12">
            <!-- 手机图片 -->
            <div class="phone-container flex-shrink-0 lg:w-[50%] xl:w-p[50%] lg:ml-12 mx-auto">
              <img :src="getImageUrl('image_market_phone', '/assets/image3.png')" alt="">
            </div>

            <!-- 文字说明 -->
            <div class="content-container flex-1 text-center lg:text-left">
              <h3 class="text-2xl lg:text-3xl font-bold text-orange-600 mb-6">
                {{ getContent('home_market_insight_title', '市场洞察') }}
              </h3>
              <ul class="space-y-4">
                <li class="text-lg text-gray-700 flex items-center gap-2">
                  <img :src="getImageUrl('image_market_indicator_1', '/assets/容器.png')" alt="">{{ getContent('home_market_insight_1', '一键识别市场风向标') }}
                </li>
                <li class="text-lg text-gray-700 flex items-center gap-2">
                  <img :src="getImageUrl('image_market_indicator_2', '/assets/容器(1).png')" alt="">{{ getContent('home_market_insight_2', '实时动态，尽在掌握') }}
                </li>
                <li class="text-lg text-gray-700 flex items-center gap-2">
                  <img :src="getImageUrl('image_market_indicator_3', '/assets/容器(2).png')" alt="">
                  {{ getContent('home_market_insight_3', '洞察市场异动，把握投资先机') }}
                </li>
              </ul>
            </div>
          </div>

          <!-- 行业解析板块 -->
          <div class="analysis-block flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            <!-- 手机图片 -->
            <div class="phone-container flex-shrink-0 lg:w-[50%] xl:w-p[50%] lg:mr-12">
              <img :src="getImageUrl('image_industry_phone', '/assets/image3.png')" alt="">
            </div>

            <!-- 文字说明 -->
            <div class="content-container flex-1 text-center lg:text-left">
              <h3 class="text-2xl lg:text-3xl font-bold text-orange-600 mb-6">
                {{ getContent('home_industry_title', '行业解析') }}
              </h3>
              <ul class="space-y-4">
                <li class="text-lg text-gray-700 flex items-center gap-2">
                  <img :src="getImageUrl('image_industry_indicator_1', '/assets/容器4.png')" alt="">{{ getContent('home_industry_1', '热力图直观呈现行业趋势，快速定位投资新板块') }}
                </li>
                <li class="text-lg text-gray-700 flex items-center gap-2">
                  <img :src="getImageUrl('image_industry_indicator_2', '/assets/容器5.png')" alt="">{{ getContent('home_industry_2', '洞察产业链上下游，捕捉精细化投资机会') }}
                </li>
                <li class="text-lg text-gray-700 flex items-center gap-2">
                  <img :src="getImageUrl('image_industry_indicator_3', '/assets/容器6.png')" alt="">{{ getContent('home_industry_3', '深度分析行业动向，解读趋势背后的核心驱动要素') }}
                </li>
              </ul>
            </div>
            <!-- 小卡组（位于手机旁） -->

          </div>

          <!-- 个股分析板块 -->
          <div class="analysis-block relative flex flex-col lg:flex-row-reverse items-center gap-8 lg:gap-12">
            <!-- 手机图片 -->
            <div class="phone-container flex-shrink-0 lg:w-[50%] xl:w-p[50%] lg:ml-12 mx-auto">
              <img :src="getImageUrl('image_stock_phone', '/assets/image3.png')" alt="">
            </div>

            <!-- 文字说明 -->
            <div class="content-container flex-1 text-center lg:text-left">
              <h3 class="text-2xl lg:text-3xl font-bold text-orange-600 mb-6">
                {{ getContent('home_stock_title', '个股分析') }}
              </h3>
              <ul class="space-y-4">
                <li class="text-lg text-gray-700 flex items-center gap-2">
                  <img :src="getImageUrl('image_stock_indicator_1', '/assets/容器7.png')" alt="">{{ getContent('home_stock_1', '洞察关键指标的联动效应，看清此消彼长') }}
                </li>
                <li class="text-lg text-gray-700 flex items-center gap-2">
                  <img :src="getImageUrl('image_stock_indicator_2', '/assets/容器8.png')" alt="">{{ getContent('home_stock_2', '构建更完整的投资逻辑追踪产品与市场趋势') }}
                </li>
                <li class="text-lg text-gray-700 flex items-center gap-2">
                  <img :src="getImageUrl('image_stock_indicator_3', '/assets/容器9.png')" alt="">{{ getContent('home_stock_3', '对比同业表现，发掘潜在投资机会') }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Page Content Container -->
    <!-- 功能模块：更智慧、更快捷、更安全的全球交易体验 -->
    <section class="features-section bg-white py-16 lg:py-20">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <h2 class="text-3xl lg:text-4xl font-bold text-gray-800 text-center mb-12">
          {{ getContent('home_features_title', '更智慧、更快捷、更安全的全球交易体验') }}
        </h2>

        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10">
          <!-- 一站式服务 -->
          <div class="feature-card text-center p-6">
              <!-- globe icon placeholder -->
             <img :src="getImageUrl('image_feature_1', '/assets/zh1.png')" alt="">
            <h3 class="font-bold text-gray-900 mb-2">{{ getContent('home_feature_1_title', '一站式服务，直通全球市场') }}</h3>
            <p class="text-sm text-gray-500">{{ getContent('home_feature_1_desc', '覆盖香港、新加坡及美国市场，支持股票、ETF、期权等10+类产品交易。') }}</p>
          </div>

          <!-- 值得信赖平台 -->
          <div class="feature-card text-center p-6">
            <img :src="getImageUrl('image_feature_2', '/assets/zh2.png')" alt="">
            <h3 class="font-bold text-gray-900 mb-2">{{ getContent('home_feature_2_title', '值得信赖平台上交易') }}</h3>
            <p class="text-sm text-gray-500">{{ getContent('home_feature_2_desc', '我们的平台每秒处理20,000笔订单，7x24小时稳定运行，并支持自动故障转移。') }}</p>
          </div>

          <!-- 超低延迟 -->
          <div class="feature-card text-center p-6">
            <img :src="getImageUrl('image_feature_3', '/assets/zh3.png')" alt="">
            <h3 class="font-bold text-gray-900 mb-2">{{ getContent('home_feature_3_title', '超低延迟，极速交易') }}</h3>
            <p class="text-sm text-gray-500">{{ getContent('home_feature_3_desc', '市场延迟低至10毫秒，报价处理1毫秒，凭借超低延迟，助您抢占先机。') }}</p>
          </div>

          <!-- 智能订单 -->
          <div class="feature-card text-center p-6">
            <img :src="getImageUrl('image_feature_4', '/assets/zh4.png')" alt="">
            <h3 class="font-bold text-gray-900 mb-2">{{ getContent('home_feature_4_title', '智能订单，适配所有策略') }}</h3>
            <p class="text-sm text-gray-500">{{ getContent('home_feature_4_desc', '借助先进的条件单、算法单和实时交易单，精准执行您的策略。') }}</p>
          </div>

          <!-- 随时随地 -->
          <div class="feature-card text-center p-6">
            <img :src="getImageUrl('image_feature_5', '/assets/zh5.png')" alt="">
            <h3 class="font-bold text-gray-900 mb-2">{{ getContent('home_feature_5_title', '随时随地，轻松交易') }}</h3>
            <p class="text-sm text-gray-500">{{ getContent('home_feature_5_desc', '覆盖桌面端、移动端、网页端及OpenAPI，让投资交易随时随地尽在掌握。') }}</p>
          </div>

          <!-- 顶级安全 -->
          <div class="feature-card text-center p-6">
            <img :src="getImageUrl('image_feature_6', '/assets/zh6.png')" alt="">
            <h3 class="font-bold text-gray-900 mb-2">{{ getContent('home_feature_6_title', '顶级安全防护') }}</h3>
            <p class="text-sm text-gray-500">{{ getContent('home_feature_6_desc', '采用银行级加密、多重身份验证与全球合规标准，层层守护资产安全，让您交易无忧。') }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 荣誉展示：TOP 标识 -->
    <section class="recognitions-section bg-white py-16 lg:py-20">
      <div class="max-w-7xl mx-auto px-4 lg:px-8 text-center">
        <h2  class="text-1xl lg:text-4xl font-bold text-gray-800 text-center mb-12">
          {{ getContent('home_recognition_title', '通过我们的\'发现，认知，交易\'系统，我们赢得了投资者的信任、合作伙伴的尊重，以及行业内的认可。') }}
        </h2>

        <div class="flex flex-col lg:flex-row items-center lg:justify-center lg:space-x-20 gap-8 lg:gap-16 w-full">
          <!-- 左侧 TOP -->
          <div class="top-badge text-center relative">
            <div class="laurel-wrapper mx-auto w-full max-w-[320px] sm:max-w-[380px] lg:max-w-[480px] flex items-center justify-between gap-4 sm:gap-6">
              <img :src="getImageUrl('image_laurel_left', '/assets/ry1.png')" alt="laurel-left" class="laurel-img block sm:block w-10 h-10 sm:w-20 sm:h-20 lg:w-24 lg:h-24"/>
              <div class="laurel-center text-center">
                <div class="small-caption text-base sm:text-lg lg:text-xl font-semibold text-gray-800 mb-2 leading-tight">{{ getContent('home_top_1_text', '香港知名金融科技券商') }}</div>
                <div class="top-text top-gradient text-3xl sm:text-6xl lg:text-7xl font-extrabold">TOP</div>
              </div>
              <img :src="getImageUrl('image_laurel_right', '/assets/ry2.png')" alt="laurel-right-small" class="laurel-img block sm:block w-10 h-10 sm:w-20 sm:h-20 lg:w-24 lg:h-24"/>
            </div>
          </div>

          <!-- 右侧 TOP -->
          <div class="top-badge text-center relative">
            <div class="laurel-wrapper mx-auto w-full max-w-[320px] sm:max-w-[380px] lg:max-w-[480px] flex items-center justify-between gap-4 sm:gap-6">
              <img :src="getImageUrl('image_laurel_left', '/assets/ry1.png')" alt="laurel-left-2" class="laurel-img block sm:block w-10 h-10 sm:w-20 sm:h-20 lg:w-24 lg:h-24"/>
              <div class="laurel-center text-center">
            <div class="small-caption text-base sm:text-lg lg:text-xl font-semibold text-gray-800 mb-2 leading-tight">{{ getContent('home_top_2_text', '香港知名资产管理机构') }}</div>
                <div class="top-text top-gradient text-3xl sm:text-6xl lg:text-7xl font-extrabold">TOP</div>
              </div>
              <img :src="getImageUrl('image_laurel_right', '/assets/ry2.png')" alt="laurel-right-2" class="laurel-img block sm:block w-10 h-10 sm:w-20 sm:h-20 lg:w-24 lg:h-24"/>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 荣誉奖项网格 -->
    <section class="awards-section bg-white py-16 lg:py-24">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <h2 class="text-3xl lg:text-4xl font-bold text-gray-900 text-center mb-10">{{ getContent('home_awards_title', '荣誉奖项展示') }}</h2>

        <div class="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          <div class="award-item text-center">
            <div class="award-card mx-auto">
              <img :src="getImageUrl('image_award_1', '/assets/award1.png')" :alt="getContent('home_award_1_title', 'Adsm Smith Awards ASIA 2023 最佳外汇解决方案')" class="w-full h-auto" />
            </div>
            <div class="award-caption mt-4 text-gray-800 text-sm leading-5">
              <div>{{ getContent('home_award_1_title', 'Adsm Smith Awards ASIA 2023 最佳外汇解决方案') }}</div>
              <div class="mt-1">{{ getContent('home_award_1_subtitle', '香港 01×巨子 ICON 2021 创新美股投资应用程序') }}</div>
            </div>
          </div>

          <div class="award-item text-center">
            <div class="award-card mx-auto">
              <img :src="getImageUrl('image_award_2', '/assets/award2.png')" :alt="getContent('home_award_2_title', 'The Asset Triple A Awards 2023 最佳经济支付解决方案')" class="w-full h-auto" />
            </div>
            <div class="award-caption mt-4 text-gray-800 text-sm leading-5">
              <div>{{ getContent('home_award_2_title', 'The Asset Triple A Awards 2023 最佳经济支付解决方案') }}</div>
              <div class="mt-1">{{ getContent('home_award_2_subtitle', '香港金融精技周 2021 参展企业') }}</div>
            </div>
          </div>

          <div class="award-item text-center">
            <div class="award-card mx-auto">
              <img :src="getImageUrl('image_award_3', '/assets/award3.png')" :alt="getContent('home_award_3_title', '香港交易所 年度创新信息商')" class="w-full h-auto" />
            </div>
            <div class="award-caption mt-4 text-gray-800 text-sm leading-5">
              <div>{{ getContent('home_award_3_title', '香港交易所 年度创新信息商') }}</div>
            </div>
          </div>

          <div class="award-item text-center">
            <div class="award-card mx-auto">
              <img :src="getImageUrl('image_award_4', '/assets/award4.png')" :alt="getContent('home_award_4_title', '香港投资推广署 优质企业引入案例')" class="w-full h-auto" />
            </div>
            <div class="award-caption mt-4 text-gray-800 text-sm leading-5">
              <div>{{ getContent('home_award_4_title', '香港投资推广署 优质企业引入案例') }}</div>
            </div>
          </div>

          <div class="award-item text-center">
            <div class="award-card mx-auto">
              <img :src="getImageUrl('image_award_5', '/assets/award5.png')" :alt="getContent('home_award_5_title', '香港 01×巨子 ICON 杰出金融科技证券商')" class="w-full h-auto" />
            </div>
            <div class="award-caption mt-4 text-gray-800 text-sm leading-5">
              <div>{{ getContent('home_award_5_title', '香港 01×巨子 ICON 杰出金融科技证券商') }}</div>
            </div>
          </div>

          <div class="award-item text-center">
            <div class="award-card mx-auto">
              <img :src="getImageUrl('image_award_6', '/assets/award6.png')" :alt="getContent('home_award_6_title', '香港 01×巨子 ICON 最佳科技创新应用券商')" class="w-full h-auto" />
            </div>
            <div class="award-caption mt-4 text-gray-800 text-sm leading-5">
              <div>{{ getContent('home_award_6_title', '香港 01×巨子 ICON 最佳科技创新应用券商') }}</div>
            </div>
          </div>

          <div class="award-item text-center">
            <div class="award-card mx-auto">
              <img :src="getImageUrl('image_award_7', '/assets/award7.png')" :alt="getContent('home_award_7_title', '荣誉待补充')" class="w-full h-auto" />
            </div>
            <div class="award-caption mt-4 text-gray-800 text-sm leading-5">
              <div>{{ getContent('home_award_7_title', '荣誉待补充') }}</div>
            </div>
          </div>

          <div class="award-item text-center">
            <div class="award-card mx-auto">
              <img :src="getImageUrl('image_award_8', '/assets/award8.png')" :alt="getContent('home_award_8_title', '荣誉待补充')" class="w-full h-auto" />
            </div>
            <div class="award-caption mt-4 text-gray-800 text-sm leading-5">
              <div>{{ getContent('home_award_8_title', '荣誉待补充') }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="hidden lg:block bg-hongtu-accent">
      <div class="max-w-7xl mx-auto px-4 lg:px-8 py-8 lg:py-16">
        <div class="flex flex-col lg:flex-row items-center justify-between gap-6 lg:gap-8">
          <div class="text-center lg:text-left flex-1">
            <h2 class="text-2xl lg:text-4xl xl:text-5xl font-medium text-white mb-3 lg:mb-4 leading-tight">
              {{ getContent('home_bottom_title', '了解证劵市场，理财收益再升级') }}
            </h2>
            <p class="text-lg lg:text-2xl xl:text-3xl font-medium text-white mb-4 lg:mb-6">
              {{ getContent('home_bottom_subtitle', '多维度分析市场表现') }}
            </p>
            <button @click="goToRegister" style="cursor: pointer;" class="btn-touch bg-hongtu-secondary text-white px-8 py-3 lg:px-6 lg:py-3 rounded-full font-medium hover:bg-hongtu-primary transition-colors duration-200 text-base lg:text-lg">
              {{ getContent('home_bottom_button_text', '立即注册') }}
            </button>
          </div>
          <div class="flex-shrink-0 mt-4 lg:mt-0">
            <img :src="getImageUrl('image_logo', '../assets/23@1x.png')" :alt="getContent('home_logo_alt', '红土证券logo')" class="w-20 h-20 lg:w-auto lg:h-50 xl:w-auto xl:h-80" />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { getContentsByCategory, ContentMixin } from '../services/contentService';

export default {
  name: 'HomePage',
  mixins: [ContentMixin],
  data() {
    return {
      content: {}, // 存储从API获取的内容
      loading: true,
      error: null,
      currentLocale: localStorage.getItem('locale') || 'zh',
      showWarningBanner: true // 控制警告横幅的显示
    }
  },
  computed: {
    currentLang() {
      // 从localStorage获取当前语言，映射到API格式
      const langMap = {
        'zh': 'cn',
        'zh-Hant': 'tw',
        'en': 'en'
      };
      return langMap[this.currentLocale] || 'cn';
    }
  },
  mounted() {
    this.loadContent();
    // 监听语言切换事件
    window.addEventListener('localeChange', this.handleLocaleChange);
  },
  beforeDestroy() {
    window.removeEventListener('localeChange', this.handleLocaleChange);
  },
  methods: {

    handleLocaleChange(e) {
      if (e.detail && e.detail.locale) {
        this.currentLocale = e.detail.locale;
        this.loadContent();
      }
    },
    goToRegister() {
      window.open('https://redland.trade.wbrks.com/Webtrading', '_blank');
    },
    async loadContent() {
      try {
        this.loading = true;
        this.error = null;
        // 获取首页所有内容
        const homeContent = await getContentsByCategory('home', this.currentLang);
        this.content = homeContent;
        
        // 将获取到的内容同步到 Mixin 的数据中，避免重复请求
        this.contentData = { ...this.contentData, ...homeContent };
        
        // 提取图片URL到 imageUrls
        Object.keys(homeContent).forEach(key => {
          if (homeContent[key] && (key.startsWith('image_') || homeContent[key].startsWith('/uploads/') || homeContent[key].startsWith('http'))) {
            // 如果是图片类型的key，或者是图片路径值
            this.$set(this.imageUrls, key, homeContent[key]);
          }
        });

        // 获取图片配置（如果有额外的图片配置分类）
        const imageContent = await getContentsByCategory('images', this.currentLang);
        if (imageContent) {
            Object.keys(imageContent).forEach(key => {
                this.$set(this.imageUrls, key, imageContent[key]);
            });
        }

      } catch (error) {
        console.error('加载内容失败:', error);
        this.error = error.message;
      } finally {
        this.loading = false;
      }
    },
    // 获取内容的辅助方法，如果API没有返回则使用默认值
    getContent(key, defaultValue = '') {
      return this.content[key] || defaultValue;
    },
    // 关闭警告横幅
    closeWarningBanner() {
      this.showWarningBanner = false;
    }
  }
}
</script>
